import axios from 'axios'
import { getLocalAuthToken } from 'Utils/LocalStorageHandler'

function getConfig(generatedToken) {
  const token = generatedToken || getLocalAuthToken()

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'accept-language': 'en-US',
      'content-type': 'application/json'
    }
  }
}

function handleResponse(response, callback) {
  if (callback) {
    callback(null, response.data)
  }

  return response
}

function handleResponseError(error, callback) {
  if (callback) {
    callback(error.response.data, null)
  }

  return Promise.reject(error)
}

const coffeeWebApiService = {
  get: async (url, token, callback) =>
    await axios
      .get(url, getConfig(token))
      .then((response) => handleResponse(response, callback))
      .catch((error) => handleResponseError(error, callback)),

  post: async (url, token, body, callback) =>
    await axios
      .post(url, body, getConfig(token))
      .then((response) => handleResponse(response, callback))
      .catch((error) => handleResponseError(error, callback)),

  put: async (url, token, body, callback) =>
    await axios
      .put(url, body, getConfig(token))
      .then((response) => handleResponse(response, callback))
      .catch((error) => handleResponseError(error, callback)),

  delete: async (url, token, callback) =>
    await axios
      .delete(url, getConfig(token))
      .then((response) => handleResponse(response, callback))
      .catch((error) => handleResponseError(error, callback)),

  patch: async (url, token, body, callback) =>
    await axios
      .patch(url, body, getConfig(token))
      .then((response) => handleResponse(response, callback))
      .catch((error) => handleResponseError(error, callback))
}

export default coffeeWebApiService
